import { toast } from "react-toastify";
import { observable } from "mobx";
import { api, apiOperacao } from "../../api";
import { toast_error } from "../../utils";

export class _DetStore {
  obs = observable({
    loading_tasks: false as boolean,
    tasks_det: [] as any,
    tasks_length: 0 as number,
    mensagens_det: [] as any,
    mensagens_length: 0 as number,
    loading_mensagens: false as boolean,
    selectedTab: "tarefas" as string,
    programar_dec: false as boolean,
    mensagens_pendentes: [] as any,
    open_empresas_mensagens: false as boolean,
  })

  async handleTasksPaged(paged: number, cnpj: string) {

    try {

      let data = {
        page: paged,
        limit: 15,
        cnpj: (cnpj || null),
      }

      let resp = await apiOperacao("det").post("/det/task/index", data);

      this.obs.tasks_det = [];
      this.obs.tasks_length = 0

      if (resp.data.count) {

        this.obs.tasks_det = resp.data.itens;
        this.obs.tasks_length = resp.data.count;

      } else {

        toast.warning('Nenhuma solicitação foi encontrada.', {});

      }

    } catch (ex) { }

    this.obs.loading_tasks = false

  }

  async handleMensagensPaged(paged: number, cnpj: string) {

    try {

      let data = {
        page: paged,
        limit: 15,
        cnpj: cnpj,
      }

      let resp = await apiOperacao("det").post("/det/index", data);

      this.obs.mensagens_det = [];
      this.obs.mensagens_length = 0

      if (resp.data.count) {

        this.obs.mensagens_det = resp.data.itens;
        this.obs.mensagens_length = resp.data.count;

      } else {

        toast.warning('Nenhuma mensagem foi encontrada.', {});

      }

    } catch (ex) { }

    this.obs.loading_mensagens = false

  }

  async handleSaveLog(row: any) {

    try {

      let resp = await apiOperacao("det").get(`/det/msg/visualiza/${row._id}`)

      if (resp.data.ok) {
        return true
      }

    } catch(ex) {}

    return false

  }

  async handleConsultaMensagens() {

    try {
      let resp = await apiOperacao("det").get("/det/index/count");

      this.obs.mensagens_pendentes = []

      if (resp.status == 200) {
        this.obs.mensagens_pendentes = resp.data
      }

    } catch (ex) {

      toast_error(ex, `Erro ao consultar Mensagens pendentes, tente novamente mais tarde.`);

    }

  }

}

export const DetStore = new _DetStore();
